import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AppUiModule } from '../../ui/app-ui.module';
import { SharedModule } from '../../shared/shared.module';
import { NotificationsRoutingModule } from './notifications-routing.module';
import { NotificationsListComponent } from './notifications-list/notifications-list.component';
import { NotificationsListFilterComponent } from './notifications-list/components/notifications-list-filter/notifications-list-filter.component';
import { NotificationsTableComponent } from './notifications-list/components/notifications-table/notifications-table.component';

@NgModule({
  declarations: [NotificationsListComponent, NotificationsListFilterComponent, NotificationsTableComponent],
  imports: [CommonModule, AppUiModule, SharedModule, NotificationsRoutingModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class NotificationsModule {}
